import React, { useState } from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import 'assets/scss/consent-box.scss';
import ConsentModal from 'components/modals/ConsentModal';

interface ConsentBoxProps {
	name: string;
	control: Control<FieldValues>;
	defaultValue?: boolean;
	label?: string;
}

export const ConsentBoxLayout = ({ name, control, defaultValue = false }: ConsentBoxProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue}
			render={({ field: { value, onChange }, fieldState: { error } }) => {
				const handleBoxClick = () => {
					if (!value) {
						setIsModalOpen(true);
					} else {
						onChange(false);
					}
				};

				const handleAcceptModal = () => {
					setIsModalOpen(false);
					onChange(true);
				};

				const handleCloseModal = () => {
					setIsModalOpen(false);
					onChange(false);
				};

				return (
					<div className="consent-field-container">
						<div className={`consent-box ${value ? 'is-checked' : ''}`} onClick={handleBoxClick}>
							<div className="consent-box-content">
								<div className="custom-check-wrapper">
									<input type="checkbox" checked={value} readOnly className="consent-box-input" />
									<div className="consent-box-checkmark" />
								</div>

								<span className="consent-box-text">
									Autorizo expresamente a BK Servicios Financieros para que consulte mi información
									contenida en el{' '}
									<span className="consent-box-link">Registro de Deuda Consolidada (REDEC)</span>,
									administrado por la CMF, para evaluar la solicitud de crédito conforme a la Ley Nº
									21.680.
								</span>
							</div>
						</div>

						{error && <span className="consent-error-message">{error.message}</span>}

						<ConsentModal
							isOpen={isModalOpen}
							onClose={handleCloseModal}
							onAccept={handleAcceptModal}
						/>
					</div>
				);
			}}
		/>
	);
};
